import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';
import {toFormikValidationSchema} from 'zod-formik-adapter';

import {FormWithButtons} from '@flexinet/ui-components';

import {
    Customer,
    CustomerStatus
} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<Customer, 'id'>,
    handleSubmit: (values: Customer) => void,
    handleCancel?: () => void
}) => {

    const onSubmit = (values: Customer) => {

        console.debug(values)


        handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {
        status: 'ACTIVE' as CustomerStatus,
        contactInfo: {
            email: '',
            phone: '',
            website: ''
        }
    } as unknown as Customer;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    console.debug(initialValues)

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={toFormikValidationSchema(RecordSchema)}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
